import * as React from 'react';
import { withStyles } from '@material-ui/core';
import MuiInput, { InputClassKey } from '@material-ui/core/Input';

import { SelectClassKey } from '@material-ui/core/Select';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { DSSelect } from './DSSelect';

export type DSSelectBoldProps = Omit<Parameters<typeof DSSelect>[0], 'input'>;

const StyledInput: typeof MuiInput = withStyles<Extract<InputClassKey, 'input' | 'root'>>(theme => ({
    input: {
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightBold as number,
        padding: theme.spacing(1.4, 0, 0.5),
    },
    root: {
        '&:after': {
            borderBottomColor: theme.palette.secondary.main,
        },
        '&:before': {
            borderBottomColor: theme.palette.primary.main,
            borderBottomWidth: 2,
        },
        '&:hover': {
            '&:before': {
                borderBottomColor: `${theme.palette.secondary.main} !important`,
            },
        },
    },
}))((props: Parameters<typeof MuiInput>[0]) => <MuiInput {...props} />) as typeof MuiInput;

export const DSSelectBold: typeof DSSelect = withStyles<Extract<SelectClassKey, 'icon' | 'iconOpen'>>(theme => ({
    icon: {
        color: theme.palette.primary.main,
    },
    iconOpen: {
        color: theme.palette.secondary.main,
    },
}))((props: DSSelectBoldProps) => (
    <DSSelect
        {...props}
        IconComponent={iconProps => <KeyboardArrowDownIcon {...iconProps} color="primary" />}
        input={<StyledInput />}
    />
)) as typeof DSSelect;
DSSelectBold.displayName = 'DSSelectBold';
